module.exports = __webpack_public_path__ + "static/media/toilet.09f0c8c9.png";